import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HorizontalMenuDTO } from '../../../app/api/models';
import { SharedService } from 'src/app/services/shared.service';
import { RoleEnum } from 'src/app/enums/role-enum';


@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent {

  @Input() options: HorizontalMenuDTO[] = [];
  @Output() handlerOption = new EventEmitter();

  @Input() hasAction: boolean = false;
  @Input() actionLabel: any;
  @Input() buttonStyleType = 'flat';
  @Input() buttonDisabled: boolean = false;
  @Input() buttonVisible: boolean = true;
  @Output() actionHandler = new EventEmitter();

  constructor(public sharedService: SharedService) { }

  optionHandler(event: HorizontalMenuDTO) {
    this.handlerOption.emit(this.options.indexOf(event));
  }

  actionHandlerPressed(event: any) {
    if (!this.buttonDisabled) {
      this.actionHandler.emit(event);
    }
  }

  isOptionVisible(option: HorizontalMenuDTO) {
    let role = this.sharedService.userRole;
    switch (role) {
      case RoleEnum.LOGISTIC_READONLY:
      case RoleEnum.LOGISTIC: return true;
      case RoleEnum.WELCOME: {
        switch (option.optionName) {
          case "Booked for sales":
          case "WATCHES": return false;
          default: return true;
        }
      };
      default: return true;
    }
  }

}
